<script>
export default {
  name: "NameComponent",
  props: {
    value: {
      type: String,
      required: true
    },
    notaries: {
      type: Array,
      required: true
    },
    searchSubmitHandler: {
      type: Function,
      required: true
    },
    selectNotaryHandler: {
      type: Function,
      required: true
    }
  }
}
</script>

<template>
  <div class="form-group">
    <input
      type="text"
      class="form-control"
      placeholder="Введите ФИО нотариуса"
      :value="value"
      @input="$emit('update:value', $event.target.value)"
      @keyup="searchSubmitHandler"
    />
    <ul class="notary-list" v-if="notaries.length">
      <li v-for="notaryItem in notaries" :key="notaryItem.id">
        <a href="#" @click="(e) => selectNotaryHandler(e, notaryItem)">
          {{ notaryItem.name }} ({{notaryItem.region.name}})
        </a>
      </li>
    </ul>
  </div>
</template>

<style scoped>

.form-group {
  margin-bottom: 0;
  position: relative;
}

.notary-list {
  position: absolute;
  left: 0;
  top: 33.5px;
  z-index: 2;
  width: 100%;
  max-height: 145px;
  overflow-y: auto;
}

.notary-list li a {
  display: block;
  width: 100%;
  height: 100%;
  padding: 7px 10px;
  background-color: #ffffff;
  border: 1px solid #CCC;
  border-top: none;
  text-decoration: none;
  color: #000000;
}

.notary-list li a:hover {
  background-color: #ededed;
}

</style>
